type InfoRowProps = {
  icon?: React.ReactNode; // pass a lucide icon or leave empty
  children: React.ReactNode;
};

export const InfoRow = ({ icon, children }: InfoRowProps) => (
  <div className="flex items-start gap-4">
    {/* fixed-width icon slot */}
    <div className="w-5 h-5 flex items-center justify-center">
      {icon}
    </div>
    <div>{children}</div>
  </div>
);